import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AdvancedSearchService } from '../services/advanced-search-service/advanced.search.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AgentscriptService } from '../services/agentscript-services/agentscript.service';
import { Router } from '@angular/router';
// import { TableauReportsService } from '../SmartReporter/sm-Services/tableau-reports.service';
// import { ApiService } from '../SmartReporter/sm-Services/api.service';
// import { LoginService } from '../SmartReporter/sm-Services/login.service';
// import { NotificationService } from '../SmartReporter/sm-Services/notification.service';
declare var $ : any;
//var dt = require('datatables.net');
require('../../assets/vendor/js/dataTableDateSorting.js');
export class SearchResults{
  Id:number;
  FirstName:string;
  LastName:string;
  Gender:string;
  DateOfBirth:string;
}
@Component({
  selector: 'app-sample2',
  templateUrl: './sample2.component.html',
  styleUrls: ['./sample2.component.scss']
})
export class Sample2Component  implements OnInit {

  site_name: string = "";
  site_id: string = "";
  auth_token: string = "";

//   ngAfterViewInit(): void
//   {
//     this._api.getmapingFactData();
//     localStorage.setItem("currentUser","2")
//     localStorage.setItem("roletypeid","1")
// console.log(localStorage.getItem("currentUser"));
// console.log(localStorage.getItem('roletypeid'));
// this.login();
// this.loginservice.getuserdetails();
// // this._api.getmapingFactData();
// this._api.getUsers();
// this._api.getGroups();
// this._api.Getroletype();
// this.notificationservice.getallnotifications();
// this._api.getIfUserExistOrNot();
//   this._api.getIfEmailExistOrNot();
//   }
//   login() {
//     this.tableau_data.login().subscribe(data => {
//       if (data.credentials.site.contentUrl == "") {
//         this.site_name = "Default"
//       }
//       else {
//         this.site_name = data.credentials.site.contentUrl;
//       }
//       this.site_id = data.credentials.site.id;
//       this.auth_token = data.credentials.token;
//       this._api.site_id = data.credentials.site.id;
//       this._api.auth_token = data.credentials.token;

//     })
//   }

  constructor(
    // private tableau_data: TableauReportsService, private _api: ApiService, private loginservice: LoginService, public notificationservice:NotificationService,
    private formBuilder: FormBuilder,private advSearch:AdvancedSearchService,private agentScriptService:AgentscriptService) { }
  advancedSearch: FormGroup;
  submitted = false;
  resultList: SearchResults[] = [];
  resultArray: SearchResults[] = [];
  searchKeys = ['Id','FirstName','LastName','DateOfBirth','Gender','birthlocation'];
	sortBy = 'Id';
	sortDesc = false;
	perPage = 10;
	totalItems = 0;
	filterVal = '';
	currentPage = 1;
  infoMsg: boolean;
  errMsg:boolean = false;
  loading:boolean = false;
  facilities:any = [];
  @Output() componentSelection = new EventEmitter<any>();
  SortByName(x,y) {
    return ((x.value == y.value) ? 0 : ((x.value > y.value) ? 1 : -1 ));
  }
  ngOnInit() {
    this.agentScriptService.getMenus(92).subscribe(data=>{
      for(let key in data){
        if(data[key].active===true || data[key].active===''){
          this.facilities.push({
            "key" : data[key].id,
            "value": data[key].valueen
          });
        }
      }
      if(this.facilities){
        this.facilities.sort(this.SortByName);
      }
      //console.log(this.facilities);
    });
    this.advancedSearch = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      dobStart: [''],
      dobEnd: [''],
      id:[''],
      birthFacility:[''],
      motherDobStart:[''],
      motherDobEnd:[''],
      motherLastName:[''],
      motherFirstName:['']
    });

    this.advancedSearch.get('dobStart').valueChanges.subscribe(x => {
      //console.log(x)
      this.advancedSearch.get('dobEnd').setValue(x);
    });
    this.advancedSearch.get('motherDobStart').valueChanges.subscribe(x => {
     // console.log(x)
      this.advancedSearch.get('motherDobEnd').setValue(x);
    });

  }



  get advancedSearchFormData() { return this.advancedSearch.controls; }
  advancedSearchSubmit() {

    this.submitted = true;

    this.errMsg = false;
    if (this.advancedSearch.invalid) {
      return;
    }
    if(this.advancedSearchFormData.dobStart.value != ''){
      if(this.advancedSearchFormData.dobEnd.value == ''){
        this.errMsg = true;
        return;
      }
    }
    if(this.advancedSearchFormData.dobEnd.value != ''){
      if(this.advancedSearchFormData.dobStart.value == ''){
        this.errMsg = true;
        return;
      }
    }
    // console.log(this.advancedSearch.value);
    // console.log(this.advSearch.getPayload(this.advancedSearch.value));

    this.loading = true;
    $("#data-table_wrapper").remove();
    this.advSearch.getSearchDataV1(this.advSearch.getPayload(this.advancedSearch.value)).subscribe((data:any)=>{
       if(data.payLoad){
          this.infoMsg = true;
          this.loading = false;
          this.resultList = data.payLoad;
          //console.log(this.resultList);
           //this.update();
       }else if(data.error){
          Swal.fire('Oops...', data.error, 'error');
       }
       else{
         this.resultList = [];
       }
       setTimeout(()=>{

        ($('.pane:visible #data-table') as any).dataTable({
          "language": {
            "paginate": {
              "previous": '<i class="fa-solid fa-angle-left"></i>',
              "next":'<i class="fa-solid fa-angle-right"></i>',
              "first": '<i class="fa-solid fa-angles-left"></i>',
              "last":'<i class="fa-solid fa-angles-right"></i>'
            }
          },
          order: [],
          columnDefs: [{'type':'de_date','targets':4},{'type':'de_date','targets':9}]

        });
        $("select[name='data-table_length']").focus();
      },500);
    });
  }
  get totalPages() {
		return Math.ceil(this.totalItems / this.perPage);
	}

	update() {
		console.log('Update',this.resultList);
		const data = this.filter(this.resultList);
		this.totalItems = data.length;
		this.sort(data);
		this.resultArray = this.paginate(data);
		this.infoMsg = false;
		//this.spinnerService.hide();
	}

	filter(data: SearchResults[]) {
		const filter = this.filterVal.trim().toLowerCase();
		return !filter ?
			data.slice(0) :
			data.filter(d => {
				return Object.keys(d)
				.filter(k =>  this.searchKeys.includes(k))
				.map(k => String(d[k]))
				.join('|')
				.toLowerCase()
				.indexOf(filter) !== -1 || !filter;
			});
	}

	sort(data: SearchResults[]) {
		data.sort((a: any, b: any) => {
			a = typeof (a[this.sortBy]) === 'string' ? a[this.sortBy].toUpperCase() : a[this.sortBy];
			b = typeof (b[this.sortBy]) === 'string' ? b[this.sortBy].toUpperCase() : b[this.sortBy];
			if (a < b) { return this.sortDesc ? 1 : -1; }
			if (a > b) { return this.sortDesc ? -1 : 1; }
			return 0;
		});
	}

	paginate(data: SearchResults[]) {
		const perPage = parseInt(String(this.perPage), 10);
		const offset = (this.currentPage - 1) * perPage;
		return data.slice(offset, offset + perPage);
	}

	setSort(key) {
		if (this.sortBy !== key) {
			this.sortBy = key;
			this.sortDesc = false;
		} else {
			this.sortDesc = !this.sortDesc;
		}
		this.currentPage = 1;
		this.update();
	}
  public componentSelectionEmitter(componentData: object) {
    //console.log(componentData);
    this.componentSelection.emit(componentData);
  }

  public somethingChanged()
  {


  }
  getDate(data){
    let dd :any,mm:any,yyyy:any,d:any;
    d = new Date(data);
    dd = d.getDate();mm = d.getMonth()+1; yyyy = d.getFullYear();
    if(dd<10) {dd='0'+dd;}
    if(mm<10) {mm='0'+mm;}
    d = mm+'/'+dd+'/'+yyyy;
    return d;
  }

  // reset(){
  //   this.advancedSearch.reset();
  // }
}
